module.exports = __webpack_public_path__ + "img/sandwich-panel.a644f26.svg";